import { getCookies } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { Navigate } from 'react-router';

interface IPrivate {
    element: React.ReactNode;
}

/**
 * PrivateRoute
 * ------------
 * Primary authentication guard. Ensures the user has a valid token.
 * Access control is handled deeper by PermissionRoute or the Sidebar.
 */
const PrivateRoute: React.FC<IPrivate> = ({ element }) => {
    const token = Boolean(
        getCookies(`${import.meta.env.VITE_BUSINESS}token`),
    );

    if (!token) {
        return <Navigate to={RoutesLink.authRoutes.login} replace />;
    }

    return <>{element}</>;
};

export default PrivateRoute;
